<template>
  <div class="app-container view-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :search-btn-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
          <el-col :span="colSpan">
            <BjFormItemCode
              v-model="queryParams.code"
              :label="$t('BusinessPurchaseApply.header.code')"
              prop="code"
              :placeholder="$t('BusinessPurchaseApply.header.code')"
              @keyup.enter.native="handleQuery"
            />
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseOrderList.order')" prop="purchaseCode">
              <BjInput
                v-model="queryParams.purchaseCode"
                :maxlength="MAX_LENGTH.DEFAULT"
                :placeholder="$t('BusinessPurchaseOrderList.order')"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseOrderList.type')" prop="purchaseType">
              <BjSelectLov v-model="queryParams.purchaseType" :placeholder="$t('BusinessPurchaseOrderList.type')" :option-list="PURCHASE_TYPE" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseApply.status')" prop="status">
              <BjTooltip :content="$t('BusinessPurchaseApply.status')">
                <BjSelectLov v-model="queryParams.status" :placeholder="$t('BusinessPurchaseApply.status')" :option-list="PURCHASE_STATUS_LIST" />
              </BjTooltip>
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseApply.isFill')">
                <BjSelectLov v-model="queryParams.isFill" :placeholder="$t('BusinessPurchaseApply.isFill')" :option-list="STATUS_YES_NUM" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <BjFormItemCode
              v-model="queryParams.skuCode"
              :label="$t('BusinessPurchaseApply.header.skuCode')"
              prop="skuCode"
              :placeholder="$t('BusinessPurchaseApply.header.skuCode')"
              @keyup.enter.native="handleQuery"
            />
          </el-col>
      </template>
      <template v-slot:seniorForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseApply.header.applicant')">
              <BjInput v-model="queryParams.buyerName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessPurchaseApply.header.applicant')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseApply.header.arrivalTime')">
              <BjDateTimerangePicker v-model="queryParamsTime_expected" :placeholder="$t('BusinessPurchaseApply.header.arrivalTime')" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('table.createTimeText')">
              <BjDateTimerangePicker v-model="queryParamsTime_create" :placeholder="$t('table.createTimeText')" />
            </el-form-item>
          </el-col>
      </template>
      <template v-slot:beforeSearchBtn>
        <el-col :span="24 - colSpan">
          <BjStatusTabs
            :value="auditTabsValue"
            :option-list="TAB_LIST"
            @handleTabClick="handleTabClick"
          />
        </el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
          <el-button :disabled="tableOperationProp.notSingle" type="primary" @click="copyPurchaseOrder">{{ $t('BusinessPurchaseApply.copyPurchaseOrder') }}</el-button>

          <!-- <el-dropdown v-hasDropdownChildren @command="handleCommand">
            <el-button type="primary">
              {{ $t('BusinessPurchaseApply.review') }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-permission:BusinessPurchaseApplyIndex_Audit
                :command="$t('BusinessPurchaseApply.review')"
                :disabled="tableOperationProp.notSelected"
                >{{ $t('BusinessPurchaseApply.review') }}</el-dropdown-item
              >
              <el-dropdown-item
                v-permission:BusinessPurchaseApplyIndex_UnAudit
                :command="$t('BusinessPurchaseApply.antiAudit')"
                :disabled="tableOperationProp.notSingle"
                >{{ $t('BusinessPurchaseApply.antiAudit') }}</el-dropdown-item
              >
              <el-dropdown-item
                v-permission:BusinessPurchaseApplyIndex_Close
                :command="$t('closeText')"
                :disabled="tableOperationProp.notSingle"
                >{{ $t('BusinessPurchaseApply.closeApplication') }}</el-dropdown-item
              >
              <el-dropdown-item
                v-permission:BusinessPurchaseApplyIndex_Cancel
                :command="$t('cancelText')"
                :disabled="tableOperationProp.notSingle"
                >{{ $t('cancelText') }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown> -->
<!--          <el-button v-permission:BusinessPurchaseApplyIndex_Export type="primary" @click="onExport">{{ $t('BusinessPurchaseApply.export') }}</el-button>-->
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="{ row }">
              <template v-if="false" />
              <template v-else-if="col.prop === 'code'">
                <span class="link" @click="onDetail(row)">{{ row[col.prop] }}</span>
                <BjCopyIcon :copy="row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'purchaseCode'">
                <span class="link" @click="toPurchase(row)">{{ row[col.prop] }}</span>
                <BjCopyIcon :copy="row[col.prop]" />
              </template>
              <el-tag v-else-if="col.prop === 'isFill'" :type="row[col.prop] ? 'success' : 'info'">{{ $t(STATUS_YES_NUM.bjGet(row[col.prop])) }}</el-tag>
              <template v-else-if="col.prop === 'status'">{{ $t(PURCHASE_STATUS_LIST.bjGet(row[col.prop])) }}</template>
              <template v-else-if="col.prop === 'purchaseType'">{{ $t(PURCHASE_TYPE.bjGet(row[col.prop])) }}</template>
              <template v-else-if="col.prop === 'skuCode'">
                {{ row.goodsList[0] ? row.goodsList[0].skuCode : '' }}
              </template>
              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template v-slot="{ row }">
              <el-button type="text" class="view-btn" @click="onDetail(row)">{{ $t('BusinessPurchaseOrderList.View') }}</el-button>
              <el-button v-if="row.status === 'CANCELLED'" type="text" class="delete-btn" @click="onDelete(row)">{{ $t('delText') }}</el-button>
              <el-button v-if="!operationList.includes(row.status)" type="text" :disabled="row.status === 'THIRD_AUDIT_REJECTED'" @click="onEdit(row)">{{ $t('editText') }}</el-button>
              <el-button v-if="!operationList.includes(row.status) && auditTabsValue!=='all'" type="text" :disabled="row.status === 'THIRD_AUDIT_REJECTED'" @click="onAudit(row)">{{ $t('BusinessPurchaseApply.review') }}</el-button>
              <el-button v-if="!operationList.includes(row.status)" type="text" @click="onAbandon(row)">{{ $t('BusinessPurchaseOrderList.Abandoned') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!--废弃弹窗-->
    <BjDialog :title="$t('BusinessPurchaseApply.cancelledPurchase')" :visible="visible" width="600px" @close="visible = false">
      <h4>{{ $t('BusinessPurchaseApply.cancelReason') }}:</h4>
      <BjInput
        v-model="form.cancelReason"
        type="textarea"
        :placeholder="$t('inputText')"
        :maxlength="MAX_LENGTH.REMARK"
        show-word-limit
        clearable
        rows="5"
      ></BjInput>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="onAbandonConfirm">{{ $t('okText') }}</el-button>
    </span>
    </BjDialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import BjDialog from '@/packages/BjDialog';
import { purchaseApi } from '@/api';
import {STATUS_YES_TRUE, STATUS_YES_NUM, PURCHASE_STATUS_LIST, PURCHASE_TYPE} from '@/utils/constants';
import { downloadBlob } from '@/utils/index';

export default {
  name: 'BusinessPurchaseApply',
  components: { BjDialog },
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_YES_TRUE,
      STATUS_YES_NUM,
      PURCHASE_STATUS_LIST,
      PURCHASE_TYPE,
      queryApi: purchaseApi.getApplys,
      // 查询参数
      queryParamsTime_expected: null,
      queryParamsTime_create: null,
      queryParams: {
        code: null,
        purchaseCode: null,
        purchaseType: null,
        status: null,
        isFill: null,
        skuCode: null,
        buyerName: null
      },
      auditTabsValue: 'all',
      TAB_LIST2: [
        {
          label: this.$t('wholeText'),
          value: 'all'
        },
        {
          label: this.$t('BusinessPurchaseOrderList.chineseAudit1'),
          value: 'WAIT_FIRST_AUDIT'
        },
        {
          label: this.$t('BusinessPurchaseOrderList.chineseAudit2'),
          value: 'WAIT_SECOND_AUDIT'
        },
        {
          label: this.$t('BusinessPurchaseOrderList.australianAudit'),
          value: 'WAIT_THIRD_AUDIT'
        },
      ],
      operationList: ['CANCELLED', 'COMPLETED', 'WAIT_PURCHASE'],
      commonErrorText: this.$t('BusinessPurchaseApply.warning1'),
      labelList: [
        { label: this.$t('BusinessPurchaseOrderList.requisition'), prop: 'code', isCheck: true, disabled: false, width: 155 },
        { label: this.$t('BusinessPurchaseOrderList.order'), prop: 'purchaseCode', isCheck: true, disabled: false, width: 170 },
        { label: this.$t('BusinessPurchaseApply.status'), prop: 'status', isCheck: true, disabled: false, width: 130},
        { label: this.$t('BusinessPurchaseApply.tableIsFill'), prop: 'isFill', isCheck: true, disabled: false, width: 175},
        { label: this.$t('BusinessPurchaseOrderList.type'), prop: 'purchaseType', isCheck: true, disabled: false, width: 160},
        { label: this.$t('BusinessPurchaseApply.header.skuCode'), prop: 'skuCode', isCheck: true, disabled: false, width: 140},
        { label: this.$t('BusinessPurchaseApply.header.arrivalTime'), prop: 'expectedDate', isCheck: true, disabled: false, width: 170},
        { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false, width: 170},
        { label: this.$t('BusinessPurchaseApply.header.applicant'), prop: 'buyerName', isCheck: true, disabled: false, width: 140},
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 195},
      ],
      visible: false,
      form: {
        cancelReason: null,
        onAbandonData: {},
      }
    };
  },
  computed: {
    permissionBtns() {
      return this.$store.state.user.permissionBtns || [];
    },
    TAB_LIST() {
      const list = this.TAB_LIST2.filter((obj) => {
        return this.permissionBtns.includes(obj.value.toLocaleLowerCase());
      }) || [];
      return [
        { label: this.$t('wholeText'), value: 'all' },
        ...list
      ];
    },
  },
  watch: {
    queryParamsTime_expected(v) {
      this.queryParams.expectedDateBegin = (v || [])[0];
      this.queryParams.expectedDateEnd = (v || [])[1];
    },
    queryParamsTime_create(v) {
      this.queryParams.creationDateBegin = (v || [])[0];
      this.queryParams.creationDateEnd = (v || [])[1];
    },
  },
  mounted() {
  },
  methods: {
    handleTabClick(tab) {
      this.auditTabsValue = tab.name;
      switch (tab.name) {
        case 'WAIT_FIRST_AUDIT':
          this.queryParams.status = 'WAIT_FIRST_AUDIT';
          break;
        case 'WAIT_SECOND_AUDIT':
          this.queryParams.status = 'WAIT_SECOND_AUDIT';
          break;
        case 'WAIT_THIRD_AUDIT':
          this.queryParams.status = 'WAIT_THIRD_AUDIT';
          break;
        default:
          this.queryParams.status = null;
      }
      this.reFresh();
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_expected = null;
      this.queryParamsTime_create = null;
      this.queryParams.code = null;
      this.queryParams.purchaseCode = null;
      this.queryParams.purchaseType = null;
      this.queryParams.status = null;
      this.queryParams.isFill = null;
      this.queryParams.skuCode = null;
      this.queryParams.buyerName = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 新增 */
    onAdd() {
      this.$router.push({
        name: 'BusinessPurchaseApplyIndexAdd',
      });
    },
    /** 复制采购单*/
    copyPurchaseOrder() {
      this.$confirm(this.$t('BusinessPurchaseApply.confirmMessage'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        const { id, code } = this.selectedRows[0];
        this.$toPage('BusinessPurchaseApplyIndexCopy', {
          id,
          code,
        });
      }).catch(() => {});
    },
    toPurchase(row) {
      this.$toPage('BusinessPurchaseDetail', {
        code: row.purchaseCode,
      });
    },
    /** 删除 */
    onDelete(row) {
      if (row.status === 'CANCELLED') {
        const ids = { id: row.id, objectVersionNumber: row.objectVersionNumber };
        this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(_ => {
          purchaseApi.deleteApplys({ids: [ids]}).then(res => {
            if (!res.failed) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.$refs.BjPage.fetchData();
              }, 800);
            }
          });
        });
      }
    },
    /** 查看*/
    onDetail(row) {
      this.$toPage('BusinessPurchaseApplyDetail', {
        id: row.id,
        code: row.code,
        status: 'view'
      });
    },
    /** 编辑操作 */
    onEdit(row) {
      const { id, code } = row;
      this.$toPage('BusinessPurchaseApplyIndexEdit', {
        id,
        code,
      });
    },
    /** 审核 */
    onAudit(row) {
      this.$toPage('BusinessPurchaseApplyDetail', {
        id: row.id,
        code: row.code,
        status: 'audit'
      });
    },
    /** 废弃 */
    onAbandon(row) {
      this.visible = true;
      this.form.onAbandonData = null;
      this.form.onAbandonData = {
        ids: [
          { id: row.id, objectVersionNumber: row.objectVersionNumber }
        ]
      };
    },
    /** 导出 */
    onExport() {
      purchaseApi.reportApplys(this.queryParams).then(res => {
        downloadBlob(res, this.$t('BusinessPurchaseApply.applicationExport') + new Date().toLocaleString() + '.xlsx');
      });
    },
    /** 废弃确认 */
    onAbandonConfirm() {
      this.$confirm(this.$t('InternalSalesOrderDetails.want'))
        .then(_ => {
          const data = {
            cancelReason: this.form.cancelReason,
            ids: this.form.onAbandonData.ids
          };
          purchaseApi.cancelApplys(data).then(res => {
            if (!res.failed) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.$refs.BjPage.fetchData();
              }, 800);
            }
          });
        })
        .catch(_ => {})
        .finally(_ => (this.visible = false));
    }
  },
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
